<template>
  <div id="experience">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <b-col lg="12" md="12">
            
            <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
              <h2 class="section-title">Professional Experience</h2>
              <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
            </div>
            <div>


              <div v-scroll-reveal="{ delay: 50 }">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>TELL Public Relations</h5>
                    <span class="text-gray">

                      <span style="color: #333;">Public Relations Intern</span>
                      <br/>
                      April 2026 - Present
                      <br/>
                      <span>Part-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Developing visibility strategies for executives, entrepreneurs, and thought leaders across media, podcasts, speaking engagements, and digital platforms.</li>
                      <li>Researching and building targeted media, podcast, and partnership lists, identifying opportunities aligned with each client's positioning and objectives.</li>
                      <li>Brainstorming messaging frameworks, campaign concepts, and compelling story angles that strengthen client credibility.</li>
                      <li>Assisting in planning and coordinating client launches, speaking engagements, and events while supporting promotional strategy before, during, and after each activation.</li>
                      <li>Shadow and contribute to strategy sessions, helping translate client goals into actionable plans.</li>
                      <li>Conducting research to inform campaign strategy, messaging, and outreach efforts.</li>
                    </ul>

                  </b-col>
                </b-row>

              </div>
              
              <div v-scroll-reveal="{ delay: 75 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Ranch Capital</h5>
                    <span class="text-gray">

                      <span style="color: #333;">Social Media Marketing Manager</span>
                      <br/>
                      January 2026 - Present
                      <br/>
                      <span>Part-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Leading content strategy across social media, aligning messaging with market updates, firm insights, and brand positioning</li>
                      <li>Writing and editing monthly financial education content optimized for SEO and client engagement</li>
                      <li>Managing production of the "View From the Ranch" podcast, including content planning, editing, and distribution across platforms</li>
                      <li>Developing monthly email newsletters and targeted campaigns, translating market insights into clear, client-friendly communication</li>
                      <li>Collaborating with advisors to translate complex financial topics into accessible, compelling content for clients and prospects</li>
                    </ul>

                  </b-col>
                </b-row>

              </div>

              <div v-scroll-reveal="{ delay: 100 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Your Brand Voice</h5>
                    <span class="text-gray">

                      <span style="color: #333;">Project Manager</span>
                      <br/>
                      Sep 2024 - Jan 2026
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Serve as a primary point of contact for multiple client organizations, supporting ongoing communications planning and execution.</li>
                      <li>Collaborate with clients to develop messaging strategies aligned with organizational goals and audience needs.</li>
                      <li>Draft, edit, and refine written communications including blogs, website copy, email messaging, press releases, and social media content.</li>
                      <li>Track campaign performance using analytics tools (e.g., Google Analytics, Meta Business Suite), identifying patterns to inform adjustments that boost lead generation and conversion rates.</li>
                      <li>Design visual assets and graphics for social media, digital ads, email campaigns, and websites, maintaining brand consistency across channels.</li>
                      <li>Create and launch targeted email campaigns via MailChimp, optimizing for engagement and deliverability.</li>
                      <li>Manage timelines, deliverables, and cross-functional collaboration in a fast-paced, multi-client environment.</li>

                    </ul>

                  </b-col>
                </b-row>

                <b-row style="margin-top: 20px;">
                  <b-col lg="3" md="4">
                    <span class="text-gray">
                      <span style="color: #333;">Digital Marketing Apprentice</span>
                      <br/>
                      Mar 2024 - Aug 2024
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Supported day-to-day communications execution for multiple client organizations.</li>
                      <li>Managed daily social media tasks across multiple client accounts, including post scheduling, audience engagement, and visual content creation.</li>
                      <li>Wrote and optimized blog posts and website content with an emphasis on clarity, tone, and audience relevance.</li>
                      <li>Collaborated with the web development team to maintain and update client websites.</li>
                      <li>Assisted in developing messaging ideas and campaign concepts during internal and client meetings.</li>
                      <li>Supported video content planning and scripting for digital communications.</li>
                    </ul>

                  </b-col>
                </b-row>

              </div>

              

              <div v-scroll-reveal="{ delay: 150 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Solomon Law Group, P.A.</h5>
                    <span class="text-gray">
                      <span style="color: #333;">Family Law Legal Assistant </span>
                      <br/>
                      March 2023 - March 2024
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Drafted professional correspondence and client communications on sensitive legal matters.</li>
                      <li>Conducted legal and policy research and synthesized findings into clear summaries.</li>
                      <li>Maintained and organized case files, ensuring all documents were up-to-date and easily accessible.</li>
                      <li>Served as a liaison between attorneys, clients, and court personnel, ensuring accurate and timely information flow.</li>
                      <li>Managed confidential information with discretion and sound judgment.</li>
                      <li>Provided empathetic and professional support to clients, addressing their concerns and questions.</li>
                      <li>Utilized case management software to track case progress and manage deadlines.</li>

                  </ul>

                  </b-col>
                </b-row>
              </div>


              <div v-scroll-reveal="{ delay: 200 }" style="padding-top: 50px;">
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Schlitzkus Law</h5>
                    <span class="text-gray">
                      <span style="color: #333;">Legal Assistant</span>
                      <br/>
                      Oct 2022 - Feb 2023
                      <br/>
                      <span>Full-time</span>
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      I learned quite a lot at the law office of Ms. Schlitzkus. Everything from ... to. blahblah blah blah blahblah blah blah
                    </p> -->
                    <ul style="padding-left: 20px;" class="bullet-list">
                      <li>Handled telephone calls, meeting plans, and acted as liaison between attorney and clients.</li>
                      <li>Maintained knowledge on case status by reviewing relevant records and reporting back to clients.</li>
                      <li>Filed pleadings and paperwork with court clerk to meet strict deadlines.</li>
                      <li>Participated in client interviews, observed questioning process and documented information.</li>
                      <li>Provided administrative support and conducted research to assist attorney in civil litigation preparation.</li>
                      <li>Drafted motions, orders, requests, notices, and other legal pleadings.</li>
                      <li>Drafted and served legal complaints, summonses, and interrogatories.</li>

                    </ul>
                  </b-col>
                </b-row>
              </div>

<!-- 
              <p class="section-subtitle" style=" font-size: 18px; margin-top: 40px;">Clients I Manage</p>

              <div v-scroll-reveal="{ delay: 50 }">
                <b-row style="margin-top: 50px;" class="justify-content-md-center">
                  <b-col cols="4" lg="2" md="4" sm="4" xs="4" v-for="(skill, index) in clients" style="margin-bottom: 40px;">
                    <div class="skillset-item">
                      <div>
                        <img :src="skill.img" />
                      </div>
                      <div class="text">
                        {{ skill.text }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div> -->


              <div style="margin-bottom: 50px; margin-top: 100px;" v-scroll-reveal="{ delay: 100 }">
                <h2 class="section-title">Involvement</h2>
                <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
              </div>


              <div v-scroll-reveal="{ delay: 100 }" >
                <b-row>
                  <b-col lg="3" md="4">
                    <h5>Child Advocate Volunteer</h5>
                    <span class="text-gray">
                      Jan 2022 - Feb 2023
                      <br/>
                      Part-time
                    </span>
                  </b-col>
                  <b-col lg="9" md="8">
                    <!-- <p>
                      Attended all court hearings related to my case assignments.
                    </p> -->
                    <ul style="padding-left: 20px;">
                      <li>Advocated for children's best interests in court proceedings through written documentation and in-person hearings.</li>
                      <li>Used OPTIMA to record notes from visitations as well as document plans, findings, results, and requests.</li>
                      <li>Communicated with legal professionals, social services, and families to support informed decision-making.</li>
                      <li>Directed parties in identifying and obtaining available benefits and community and social services.</li>
                      <li>Demonstrated commitment to equity, empathy, and ethical advocacy.</li>

                  </ul>
                  </b-col>
                </b-row>
              </div>
            </div>
        </b-col>
        <b-col lg="12" md="12">
          <div v-scroll-reveal="{ delay: 200 }">
            <div style="text-align: center; margin-top: 50px; margin-left: auto; margin-right: auto;" class="section-subtitle">Skillset</div>
            <b-row style="margin-top: 50px;">
              <b-col cols="4" lg="2" md="4" sm="4" xs="4" v-for="(skill, index) in skillItems" style="margin-bottom: 40px;">
                <div class="skillset-item">
                  <div>
                    <img :src="skill.img" />
                  </div>
                  <div class="text">
                    {{ skill.text }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <div class="skill-chips">
              <div class="skill-chip">Public Relations</div>
              <div class="skill-chip">Strategic Communications</div>
              <div class="skill-chip">Media Relations</div>
              <div class="skill-chip">Project Management</div>
              <div class="skill-chip">Personal Branding</div>
            </div>
            <!-- <div class="skill-chips">
              <div class="skill-chip">Campaign Coordination</div>
              <div class="skill-chip">Search Engine Optimization</div>
              <div class="skill-chip">Digital Content Creation</div>
            </div> -->
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      clients:[
        { 
          img: require("../../assets/img/clients/ranchcap.png"),
          text: 'Ranch Capital Advisors'
        },
        { 
          img: require("../../assets/img/clients/mitigation.png"),
          text: 'The Mitigation Banking Group, Inc.'
        },
        { 
          img: require("../../assets/img/clients/scott.png"),
          text: 'Scott Gordon Group'
        },
        { 
          img: require("../../assets/img/clients/victoria.png"),
          text: 'Victoria for Winter Springs'
        },
        // { 
        //   img: require("../../assets/img/clients/kennedy.png"),
        //   text: 'Kennedy Concrete'
        // },
        { 
          img: require("../../assets/img/clients/vinn.png"),
          text: `Lil Vinny's Pizza`
        },
        // { 
        //   img: require("../../assets/img/clients/paddy.png"),
        //   text: 'Paddy Wagon Davenport'
        // },
        // { 
        //   img: require("../../assets/img/clients/cocoa.png"),
        //   text: 'I Love Cocoa Beach'
        // },
        {
          img: require("../../assets/img/clients/hpn.png"),
          text: 'HPN Global',
        },
        {
          img: require("../../assets/img/clients/united.png"),
          text: 'United Abolitionists',
        },
        {
          img: require("../../assets/img/clients/soca.png"),
          text: 'Soca Shores',
        },
      ],
      skillItems: [
        {
          img: '/wordlogo.png',
          text: 'MS Word'
        },
        {
          img: '/excellogo.png',
          text: 'MS Excel'
        },
        {
          img: '/canvalogo.png',
          text: 'Canva'
        },
        {
          img: '/wixlogo.png',
          text: 'Wix'
        },
        {
          img: '/wordpress.png',
          text: 'WordPress'
        },
        {
          img: '/asanalogo.png',
          text: 'Asana'
        },
        {
          img: '/ganlogo.png',
          text: 'Google Analytics'
        },
        {
          img: '/mailchimplogo.png',
          text: 'MailChimp'
        },
        {
          img: '/metalogo.png',
          text: 'Meta'
        },
        {
          img: '/arlogo.png',
          text: 'Activate Reviews'
        },
        {
          img: '/zapier-logo_black.png',
          text: 'Zapier'
        },
        {
          img: '/ein.png',
          text: 'EIN Presswire'
        },
       
        // {
        //   img: '/abacuslogo.png',
        //   text: 'Abacus Law'
        // },
        // {
        //   img: '/lexisnexis.png',
        //   text: 'Lexis Nexis'
        // },
        // {
        //   img: '/timematterslogo.png',
        //   text: 'Time Matters'
        // },
        // {
        //   img: '/floridacourtslogo.png',
        //   text: 'Florida Courts E-Filing Authority'
        // }

      ]
    }
  }
}
</script>

<style lang="css">

@media only screen and (max-width: 767px) {
  .bullet-list {
    margin-top: 20px;
  }
}

.skill-chips {
  display: flex;
  margin-left: auto;
  width: fit-content;
  margin-right: auto;
}

.skill-chip {
  font-size: 14px;
  padding: 5px 12px;
  background: #ffa31830;
  color: #ffa318;
  border-radius: 10px;
  margin-left: 5px;
  margin-bottom: 10px;
  margin-right: 5px;
  text-align: center;
}

@media only screen and (max-width: 767px) {
  .skill-chips {
    display: block;
    margin-left: 0px;
  }
  .skill-chip {
    width: fit-content;
  }
}


.skillset-item { 
  /* border-radius: 15px; */
  /* box-shadow: 0px 0px 15px #00000011; */
  /* padding: 10px; */
  /* background: white; */
  text-align: center;
  font-size: 13px;
}

.skillset-item .text {
  margin-top: 10px;
  color: #333;
}
.skillset-item img {
  max-height: 50px;
}


</style>
